module.exports = __webpack_public_path__ + "static/media/trampoline.ea69b94d.png";